import { theme } from 'antd';
import { Col, Flex, Row, Skeleton } from 'zui/Antd';

const TeamDrawerSkeleton = () => {
	// ✅ Hooks
	const {
		token: { paddingXL, paddingXS }
	} = theme.useToken();

	return (
		<>
			<Row gutter={[16, 20]} style={{ marginBottom: paddingXL }}>
				<Col span={24}>
					<Flex gap={16} align='center'>
						<Skeleton.Avatar size={64} shape='circle' active />
						<Flex vertical gap={8}>
							<Skeleton.Input style={{ width: 210, height: 25 }} active />
							<Skeleton.Input style={{ width: 210, height: 25 }} active />
						</Flex>
					</Flex>
				</Col>

				<Col span={24}>
					<Skeleton.Button style={{ width: 140 }} active />
				</Col>

				<Col span={10} style={{ marginBottom: paddingXS }}>
					<Row gutter={[8, 20]}>
						{[...'1234'].map((_, i) => (
							<Col span={24} key={i}>
								<Flex align='center' gap={8} justify='space-between'>
									<Skeleton.Avatar size={24} shape='circle' active />
									<Skeleton.Input style={{ width: 100, height: 25 }} active size='small' />
									<Skeleton.Input style={{ width: 100, height: 25 }} active size='small' />
								</Flex>
							</Col>
						))}
					</Row>
				</Col>
			</Row>

			<Row gutter={[16, 32]}>
				{[...'12'].map((_, i) => (
					<Col span={24} key={i}>
						<Flex justify='space-between' align='center'>
							<Flex align='center' gap={8}>
								<Skeleton.Avatar size={24} shape='square' active />
								<Skeleton.Input style={{ width: 100, height: 25 }} active />
								<Skeleton.Avatar size={24} shape='square' active />
							</Flex>
							<Skeleton.Button style={{ width: 10, height: 25 }} active />
						</Flex>
					</Col>
				))}
			</Row>
		</>
	);
};

export default TeamDrawerSkeleton;
